import deepLinkService, { getSalesforceScreenForPath } from './deepLinkService'

export const IN_APP_SCREEN_VIEW_EVENT_NAME = 'screen_view'

export const SALESFORCE_SCREEN_EVENT_NAMES = Object.freeze({
  HOME: 'Visualizzazione Home',
  TRANSACTIONS: 'Visualizzazione Transazioni',
  RESULTS: 'Visualizzazione Risultati',
  DOCUMENTS: 'Visualizzazione Documenti',
  COMPANY_DATA: 'Visualizzazione Dati Societa',
  PERSONAL_DATA: 'Visualizzazione Dati Personali',
  SERVICES: 'Visualizzazione Prodotti e Servizi',
  COSTS: 'Visualizzazione Incassi e Commissioni',
  SUPPORT: 'Visualizzazione Assistenza'
})

const normalizePath = (pathname) => {
  if (!pathname || typeof pathname !== 'string') return null

  const pathWithoutQuery = pathname.split(/[?#]/)[0]
  if (pathWithoutQuery === '/') return '/'

  return pathWithoutQuery.replace(/\/+$/, '')
}

const routeEvents = [
  { path: deepLinkService.routes.homepage.path, eventName: SALESFORCE_SCREEN_EVENT_NAMES.HOME },
  { path: deepLinkService.routes.transactions.path, eventName: SALESFORCE_SCREEN_EVENT_NAMES.TRANSACTIONS },
  { path: deepLinkService.routes.results.path, eventName: SALESFORCE_SCREEN_EVENT_NAMES.RESULTS },
  { path: deepLinkService.routes.documents.path, eventName: SALESFORCE_SCREEN_EVENT_NAMES.DOCUMENTS },
  { path: deepLinkService.routes.company_data.path, eventName: SALESFORCE_SCREEN_EVENT_NAMES.COMPANY_DATA },
  { path: '/profile/personal-data', eventName: SALESFORCE_SCREEN_EVENT_NAMES.PERSONAL_DATA },
  { path: deepLinkService.routes.offers_services.path, eventName: SALESFORCE_SCREEN_EVENT_NAMES.SERVICES },
  { path: '/costs', eventName: SALESFORCE_SCREEN_EVENT_NAMES.COSTS },
  { path: deepLinkService.routes.faq.path, eventName: SALESFORCE_SCREEN_EVENT_NAMES.SUPPORT }
]

export const getSalesforceScreenEventForPath = (pathname) => {
  const normalizedPath = normalizePath(pathname)
  if (!normalizedPath) return null

  const routeEvent = routeEvents.find(({ path }) => (
    normalizePath(path)?.toLowerCase() === normalizedPath.toLowerCase()
  ))

  return routeEvent?.eventName || null
}

export const getSalesforceInAppEventsForPath = (pathname) => {
  const events = []
  const salesforceScreen = getSalesforceScreenForPath(pathname)
  const screenEventName = getSalesforceScreenEventForPath(pathname)

  if (salesforceScreen) {
    events.push({
      name: IN_APP_SCREEN_VIEW_EVENT_NAME,
      attributes: {
        deeplink_key: salesforceScreen.deepLinkKey
      }
    })
  }

  if (screenEventName) {
    events.push({ name: screenEventName })
  }

  return events
}
